import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import { CreateDrawingRequestDto, DrawingRequest, ProjectSimpleDto } from "../../types";

export const getDrawingRequests = async (propertyUid: string) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONSTRUCTION_API_URL}/properties/${propertyUid}/drawing-requests`,
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  }) as Promise<{ data: DrawingRequest[] }>;
};

export const markDrawingRequestAsFinal = async (requestUid: string) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONSTRUCTION_API_URL}/drawing-requests/${requestUid}/mark-as-final`,
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PATCH,
    },
  }) as Promise<{ data: DrawingRequest }>;
};

export const unmarkDrawingRequestAsFinal = async (requestUid: string) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONSTRUCTION_API_URL}/drawing-requests/${requestUid}/unmark-as-final`,
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PATCH,
    },
  }) as Promise<{ data: DrawingRequest }>;
};

export const createDrawingRequest = async (
  propertyUid: string,
  data: CreateDrawingRequestDto,
) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONSTRUCTION_API_URL}/properties/${propertyUid}/drawing-requests`,
  );

  const formData = new FormData();
  formData.append("customerUid", data.customerUid);
  const description = data.description?.trim();
  if (description) {
    formData.append("description", description);
  }
  if (data.file) {
    formData.append("files", data.file);
  }

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
      formData: true,
      data: formData,
    },
  }) as Promise<{ data: DrawingRequest[] }>;
};

export const getProjectByProperty = async (propertyUid: string) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONSTRUCTION_API_URL}/properties/${propertyUid}/project`,
  );
  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  }) as Promise<{ data: ProjectSimpleDto }>;
};

export const revertDrawingRequest = async (uid: string) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONSTRUCTION_API_URL}/drawing-requests/${uid}/revert`,
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PATCH,
    },
  }) as Promise<{ data: DrawingRequest }>;
};
